import React from "react"

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"

// Square tile with optional remote/hosted image or Font Awesome icon.
export const MarkTileElement: React.FunctionComponent<
    IMarkTileElementProps
> = props => {
    const dimensions =
        props.size === "large"
            ? "w-[56px] h-[56px] md:w-[64px] md:h-[64px]"
            : "w-[48px] h-[48px]"

    const iconPx = props.size === "large" ? 28 : 22

    if (props.markImageUrl) {
        const fit = props.markImageFit ?? "cover"

        if (fit === "contain") {
            return (
                <div
                    className={`
                        shrink-0 ${dimensions} rounded-[8px] overflow-hidden
                        border border-solid border-brand-warmLight2 bg-brand-white
                        ${props.className ?? ""}
                    `}
                >
                    <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-brand-white p-[4px]">
                        <img
                            src={props.markImageUrl}
                            alt={props.tileLabel}
                            className="max-h-[88%] max-w-[88%] object-contain"
                            referrerPolicy="no-referrer"
                        />
                    </div>
                </div>
            )
        }

        return (
            <div
                className={`
                    shrink-0 ${dimensions} rounded-[8px] overflow-hidden
                    border border-solid border-brand-warmLight2
                    ${props.className ?? ""}
                `}
            >
                <img
                    src={props.markImageUrl}
                    alt={props.tileLabel}
                    className="h-full w-full object-cover"
                    referrerPolicy="no-referrer"
                />
            </div>
        )
    }

    return (
        <div
            aria-hidden
            className={`
                shrink-0 ${dimensions} rounded-[8px]
                flex items-center justify-center
                border border-solid border-brand-warmLight2
                ${props.className ?? ""}
            `}
            style={{
                backgroundColor: props.backgroundColor,
            }}
        >
            <FontAwesomeIcon
                icon={props.icon}
                style={{
                    width: iconPx,
                    height: iconPx,
                    color: NIRVANA_COLORS.brand.white,
                }}
            />
        </div>
    )
}

interface IMarkTileElementProps {
    icon: IconDefinition
    backgroundColor: string
    size: "small" | "large"
    markImageUrl?: string
    markImageFit?: "cover" | "contain"
    // Screen-reader label when `markImageUrl` is set (connection name).
    tileLabel: string
    className?: string
}
